const transferData = [
  {
    id: 1,
    transferName: "JKIA - Nairobi CBD",
    vehicleTypes: [
        { type: "Sedan/Saloon(1-3 pax)", price: 2099 },
        { type: "Mini-Van(1-6 pax)", price: 4100 },
      ],
  },
  {
    id: 2,
    transferName: "JKIA - Milimani & Kilimani Zone",
    vehicleTypes: [
        { type: "Sedan/Saloon(1-3 pax)", price: 2300 },
        { type: "Mini-Van(1-6 pax)", price: 4300 },
      ],
  },
  {
    id: 3,
    transferName: "JKIA - Embakasi Road",
    vehicleTypes: [
        { type: "Sedan/Saloon(1-3 pax)", price: 2049 },
        { type: "Mini-Van(1-6 pax)", price: 4099 },
      ],
  },
  {
    id: 4,
    transferName: "JKIA - Hotels within JKIA Zone",
    vehicleTypes: [
        { type: "Sedan/Saloon(1-3 pax)", price: 1049 },
        { type: "Mini-Van(1-6 pax)", price: 2049 },
      ],
  },
  {
    id: 5,
    transferName: "JKIA - Westlands Area",
    vehicleTypes: [
        { type: "Sedan/Saloon(1-3 pax)", price: 2250 },
        { type: "Mini-Van(1-6 pax)", price: 4250 },
      ],
  },
  {
    id: 6,
    transferName: "JKIA - Upperhill Area",
    vehicleTypes: [
        { type: "Sedan/Saloon(1-3 pax)", price: 2300 },
        { type: "Mini-Van(1-6 pax)", price: 4300 },
      ],
  },
  {
    id: 7,
    transferName: "JKIA - Ngong Road Area",
    vehicleTypes: [
        { type: "Sedan/Saloon(1-3 pax)", price: 2500 },
        { type: "Mini-Van(1-6 pax)", price: 4500 },
      ],
  },
  {
    id: 8,
    transferName: "JKIA - Karen Area",
    vehicleTypes: [
        { type: "Sedan/Saloon(1-3 pax)", price: 3300 },
        { type: "Mini-Van(1-6 pax)", price: 6300 },
      ],
  },
];

transferData.forEach((car) => {
  car.description = `Explore the unmatched comfort and performance of our ${car.carName}, available at just Ksh ${car.price} per day. With a stellar rating of ${car.rating}, this versatile vehicle promises a memorable journey every time. Its transmission ensures a smooth ride, making it the ideal choice for any adventure. At Sankhu Car Rentals and Tours, our commitment to excellence extends to every vehicle we offer. Please note that our minimum rental period is 2 days. We prioritize your safety and comfort, ensuring your rental experience exceeds expectations. Book your ${car.carName} today and embark on a seamless and enjoyable drive.`;
});

export default transferData;
